module.exports = __webpack_public_path__ + "img/zzj1.2a25b63f.png";